import { ClipboardModule } from '@angular/cdk/clipboard';
import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { COPYRIGHTS } from 'app/helpers/constants';
import { UserComponent } from 'app/layout/common/user/user.component';
import { MerchantSummary } from 'app/models/merchant-dasbhoard/merchant-summary';
import { LoggedOnMerchantSummaryStore } from 'app/store/merchant.store';
import { LoggedOnUserPermissionsStore } from 'app/store/permissions.auth.store';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-wizard-complete-confirmation',
    imports: [UserComponent, MatIconModule, MatButtonModule, ClipboardModule],
    templateUrl: './wizard-complete-confirmation.component.html',
    styleUrl: './wizard-complete-confirmation.component.scss',
})
export class WizardCompleteConfirmationComponent implements OnInit {
    apiId: string | null = null;
    merchant: MerchantSummary | null = null;
    snackbar = inject(MatSnackBar);
    copyrights = COPYRIGHTS;
    store = inject(LoggedOnMerchantSummaryStore);
    store2 = inject(LoggedOnUserPermissionsStore);
    baseUrl = environment.hppUrl;

    vanityUrl: string | null = null;

    constructor(private _router: Router) {
        const navigation = this._router.getCurrentNavigation();
        this.apiId = navigation?.extras?.state?.data?.merchantApiId;
    }

    ngOnInit(): void {
        if (this.apiId) {
            this.merchant = this.store.get(this.apiId);
            this.vanityUrl = this.merchant?.vanityUrl ?? null;
        }
    }

    copiedToClipboard(): void {
        this.snackbar.open('Copied to clipboard', 'Copied', {
            verticalPosition: 'top',
            duration: 3000,
        });
    }

    done() {
        if (this.merchant?.status?.toLowerCase() === 'active') {
            this._router.navigate(['']);
        }
    }
}
